// extracted by mini-css-extract-plugin
export default {"btnGlow":"feed-data_btnGlow__lB9sx","flex":"feed-data_flex__xuwnZ","readyColor":"feed-data_readyColor__GS6tr","statusWidth":"feed-data_statusWidth__jjk9B"};